import { render } from "./VsudLoading.vue?vue&type=template&id=405157fa"
import script from "./VsudLoading.vue?vue&type=script&lang=js"
export * from "./VsudLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__